var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationClusterFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13.187 25.64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cluster-icon-full{fill:inherit}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-181.94 -552.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cluster-icon-full",
    transform: "translate(-19.404)",
    d: "m207.87 552.41h-4.954v14.865a4.955 4.955 0 0 0 9.91 0v-9.91a4.961 4.961 0 0 0-4.956-4.955zm0.056 7.321a2.069 2.069 0 1 1 2.07-2.069 2.069 2.069 0 0 1-2.07 2.069z",
    "data-name": "Pfad 13957"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cluster-icon-full",
    transform: "translate(181.94 575.8)",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    "data-name": "Ellipse 2038"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cluster-icon-full",
    transform: "translate(187.02 575.04)",
    cx: 1.505,
    cy: 1.505,
    r: 1.505,
    "data-name": "Ellipse 2039"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cluster-icon-full",
    transform: "translate(193.62 575.8)",
    cx: 0.752,
    cy: 0.752,
    r: 0.752,
    "data-name": "Ellipse 2040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationClusterFilled);
export default __webpack_public_path__ + "static/media/stationClusterFilled.4c2924d44076ff5b98b067119fafffd2.svg";
export { ForwardRef as ReactComponent };